// extracted by mini-css-extract-plugin
export var desktop_nav = "Navbar-module--desktop_nav--uFJ-y";
export var logo = "Navbar-module--logo--hEvAr";
export var menu_toggle = "Navbar-module--menu_toggle--ESFbE";
export var navbar = "Navbar-module--navbar--DpDnT";